import React, { useState } from "react";
import PropTypes from "prop-types";

import { Title, Field, Control, Button, Textarea } from "rbx";

const OrderSpecialInstructionsForm = ({
  name,
  value,
  onChange,
  disabled,
  onClose,
  label
}) => {
  const [innerValue, setInnerValue] = useState(() => value || "");

  const handleChange = e => {
    setInnerValue(e.target.value);
  };

  const handleSave = () => {
    onChange({ target: { name, value: innerValue } });
    onClose();
  };

  return (
    <div>
      <Title>{label} Special Instructions</Title>
      <Field>
        <Control>
          <Textarea
            disabled={disabled}
            name={name}
            rows="10"
            value={innerValue}
            onChange={handleChange}
          />
        </Control>
      </Field>

      <Field kind="group">
        <Control expanded />
        <Control>
          <Button color="success" type="button" onClick={handleSave}>
            Save
          </Button>
        </Control>
      </Field>
    </div>
  );
};
OrderSpecialInstructionsForm.propTypes = {
  name: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  onClose: PropTypes.func,
  label: PropTypes.string
};
export default OrderSpecialInstructionsForm;
